export async function parallel (data, func, concurrent = 5) {
  let error = false
  let i = 0
  const ret = new Array(data.length)
  const promises = new Array(concurrent).fill(null).map(async () => {
    while (i < data.length && !error) {
      try {
        const curr = i
        i++
        ret[curr] = await func(data[curr])
      } catch (e) {
        error = true
        throw e
      }
    }
  })
  await Promise.all(promises)
  return ret
}
